import script from "./InvalidationInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./InvalidationInfo.vue?vue&type=script&setup=true&lang=js"

import "./InvalidationInfo.vue?vue&type=style&index=0&id=cbf911ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbf911ce"]])

export default __exports__